// components/ChatSystem/MessageHover.jsx
import React, { useState, useEffect } from 'react';

const MessageHover = ({ text, visible }) => {
  const [position, setPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const updatePosition = (e) => {
      setPosition({ x: e.clientX + 15, y: e.clientY - 15 });
    };

    if (visible) {
      document.addEventListener('mousemove', updatePosition);
    }

    return () => {
      document.removeEventListener('mousemove', updatePosition);
    };
  }, [visible]);

  if (!text) return null;

  return (
    <div
      className={`message-hover ${visible ? 'visible' : 'hidden'}`}
      style={{
        left: `${position.x}px`,
        top: `${position.y}px`
      }}
    >
      <strong>Sent:</strong> {text}
    </div>
  );
};

export default MessageHover;